import {
  InviteProcurementSuppliersDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import {
  UseMutateAsyncFunction,
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementApi } from "@api/services";
import { ACTION_GET_CURRENT_COMPANY_INFO, DOMAIN_COMPANIES, roleGuard } from "@api";

export const ACTION_INVITE_PROCUREMENT_SUPPLIERS = "INVITE_PROCUREMENT_SUPPLIERS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const sendInviteToProcurementSuppliers = async (
  param: InviteProcurementSuppliersDto,
): Promise<void> => {
  const response =
    await procurementApi.procurementControllerInviteProcurementSuppliers(param);

  return response.data;
};

export const useSendInviteToProcurementSuppliers = (
  user: UserProfileDto | null,
): {
  inviteSuppliers: UseMutateFunction<
    void,
    Error,
    InviteProcurementSuppliersDto,
    unknown
  >;
  inviteSuppliersAsync: UseMutateAsyncFunction<
    void,
    Error,
    InviteProcurementSuppliersDto,
    unknown
  >;
  inviteSuppliersEnabled: boolean;
  isSuccessInviteSuppliers: boolean;
  isPendingInviteSuppliers: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending, mutateAsync } = useMutation({
    mutationKey: [DOMAIN_PROCUREMENT, ACTION_INVITE_PROCUREMENT_SUPPLIERS],
    mutationFn: enabled ? sendInviteToProcurementSuppliers : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_PROCUREMENT],
      });
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_INFO],
      });
    },
  });

  return {
    inviteSuppliers: mutate,
    inviteSuppliersAsync: mutateAsync,
    inviteSuppliersEnabled: enabled,
    isSuccessInviteSuppliers: isSuccess,
    isPendingInviteSuppliers: isPending,
  };
};
